import Screen from "controllers/Screen";
import Easing from "utils/Easing";
import Utils from "utils/Utils";
import Math_ from "utils/Math";
import * as PIXI from 'lib/pixi.js'
import AbstractHeader from "components/partials/interactive-header/js/AbstractHeader";


export default class AgencyHeader extends AbstractHeader {
	constructor($wrapper) {
		super($wrapper);

		this.duration = 15;

		/////// Shapes
		this.numShapes = 1;
		this.waveSize = 10;

		this.init();
	}


	raf() {
		super.raf();
		if (this.isVisible) {
			this.drawShapes();
		}
	}


	resize(isMobileH) {

		if (isMobileH) {
			return;
		}
		
		this.waveSize = Math.min(Screen.wH, Screen.wW) / 2;
		// this.numShapes = Screen.wW < 800 ? 20 : 20;
		this.numShapes = 20;
		this.killShapes();
		for (let i = 0; i < this.numShapes; i++) {
			this.addShape((1 - (1 / this.numShapes)) - (i / this.numShapes));
		}
		this.updateShapes();
		super.resize(isMobileH);


	}


	addShape(defaultCompletion = 0) {

		let shape = {},
			numPoints = Math.round(Math.random() * 8) + 3,
			points = [],
			completionTween;

		shape.completion = 0;


		// 1 . First point
		points.push({
			x: 0,
			y: Math.random()
		});

		// 2 . Create all the points
		for (let i = 0; i < numPoints; i++) {

			// 2a . Point default position
			let point = {
				x: (Math.random() / (numPoints)) + (i / (numPoints)),
				y: Math.random()
			};
			points.push(point);
		}

		// 3 . Last point
		points.push({
			x: 1,
			y: Math.random()
		});

		// 4 . Completion tween (from 0 to 1)
		completionTween = gsap.to(shape, {
			duration: this.duration,
			completion: 1,
			ease: "none",
			onComplete: () => {
				this.killShape(shape);
				this.addShape(0);
				this.updateShape(this.shapes[0]);
			}
		});
		completionTween.progress(defaultCompletion);

		// 5 . Create the shape and add to the collection
		shape.points = points;
		shape.completionTween = completionTween;
		shape.graphics = new PIXI.Graphics();
		this.pxShape.addChildAt(shape.graphics, 0);
		this.shapes.unshift(shape); // Add to the shapes collection (in first position)
	}


	updateShapes() {
		for (let shapeIndex = 0; shapeIndex < this.shapes.length; shapeIndex++) {
			this.updateShape(this.shapes[shapeIndex]);
		}
	}

	updateShape(shape) {

		let points = [];
		for (let pointIndex = 0; pointIndex < shape.points.length; pointIndex++) {
			let point = shape.points[pointIndex];
			points.push({
				x: (point.x * Screen.wW) * this.shapesResolution,	// x percent of the app width
				y: ((Screen.wH / 2) + (point.y * this.waveSize)) * this.shapesResolution
			});
		}

		// Shape
		shape.graphics.clear();
		shape.graphics.beginFill(0xFFFFFF);
		shape.graphics.moveTo(points[0].x, points[0].y);
		Utils.curveThroughPoints(points.slice(1), shape.graphics);
		shape.graphics.lineTo(Screen.wW * this.shapesResolution, 0);
		shape.graphics.lineTo(0, 0);
		shape.graphics.lineTo(0, (this.waveSize * 0.5) * this.shapesResolution);
		shape.graphics.closePath();
		shape.graphics.endFill();
	}


	drawShapes() {
		for (let shapeIndex = 0; shapeIndex < this.shapes.length; shapeIndex++) {

			const shape = this.shapes[shapeIndex],
				completion = shape.completion,
				scale = Math.max(1, 1 + Easing.easeInQuint(completion) * 2),
				scrollScale = Easing.easeInOutQuad(2 - completion) * this.scrollPercent,
				translateX = Screen.wW * 0.5,
				translateY = -(((this.realHeight * 0.5 + this.waveSize) * scale) * completion)
					+ (-this.virtualHeight * scrollScale);// Scroll effect

			// Colors
			const colorRG = 32 + (Math_.clamp(Easing.linear(completion) * this.introAlpha * (1 - this.scrollPercent), 0, 1) * (43 - 32)),
				colorB = 32 + (Math_.clamp(Easing.linear(completion) * this.introAlpha * (1 - this.scrollPercent), 0, 1) * (226 - 32));

			shape.graphics.tint = PIXI.utils.rgb2hex([colorRG / 255, colorRG / 255, colorB / 255]);
			shape.graphics.pivot.set(translateX * this.shapesResolution, 0);
			shape.graphics.x = translateX;
			shape.graphics.y = translateY;
			shape.graphics.scale.set(scale / this.shapesResolution, scale / this.shapesResolution);
		}
	}


	killShape(shape) {
		shape.graphics.clear();
		shape.graphics.destroy();
		shape.completionTween.kill();
		shape.points = null;
		this.shapes.splice(this.shapes.indexOf(shape), 1);
	}

}
